module.exports = __webpack_public_path__ + "static/media/dotnet-logo.0c02c930.png";